import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import Navbar from "./components/feature/Navbar";
import Footer from "./components/feature/Footer";

declare const __BASE_PATH__: string;

export default function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Navbar />
      <AppRoutes />
      <Footer />
    </BrowserRouter>
  );
}
